import React from 'react';
import { ParallaxImage } from './ui/ParallaxImage';
import { FadeInUp } from './ui/FadeInUp';
export function Hero() {
  return <>
      <section className="relative md:min-h-[90vh] flex flex-col justify-center pt-32 pb-12 md:pb-32 overflow-hidden" data-id="element-159">
        {/* Background image */}
        <ParallaxImage src="https://cdn.magicpatterns.com/uploads/bxHbvzwBsR8jpEb4sbadF1/cesar-cid-ZZf2xr2V-Nw-unsplash.jpg" alt="Modern Phoenix Metro desert home at sunset" overlayOpacity={0} data-id="element-160" />

        {/* Full-hero vertical gradient overlay */}
        <div className="absolute inset-0 z-[1] pointer-events-none" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.35) 40%, rgba(0,0,0,0.65) 100%)'
      }} data-id="element-161" />

        {/* Centered radial vignette behind the text block */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[2] pointer-events-none" style={{
        width: 'min(1200px, 110%)',
        height: '600px',
        background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 40%, transparent 70%)'
      }} data-id="element-162" />

        <div className="relative z-10 container max-w-[1000px] mx-auto px-6 text-center mt-0 md:mt-24" data-id="element-163">
          <FadeInUp data-id="element-164">
            <span className="block text-[11px] sm:text-[13px] md:text-[14px] font-semibold uppercase tracking-[0.2em] mb-6 text-[#F5E9D7]" data-id="element-165">
              <span className="block sm:inline" data-id="element-166">EST. 1992</span>
              <span className="hidden sm:inline text-terracotta mx-3" data-id="element-167">
                &middot;
              </span>
              <span className="block sm:inline mt-1 sm:mt-0" data-id="element-168">FAMILY OWNED</span>
              <span className="hidden sm:inline text-terracotta mx-3" data-id="element-169">
                &middot;
              </span>
              <span className="block sm:inline mt-1 sm:mt-0" data-id="element-170">
                PHOENIX METRO
              </span>
            </span>
          </FadeInUp>

          <FadeInUp delay={0.1} data-id="element-171">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-semibold text-white leading-[1.1] mb-2 md:mb-3 text-balance" style={{
            textShadow: '0 2px 4px rgba(0,0,0,0.8), 0 4px 24px rgba(0,0,0,0.6)'
          }} data-id="element-172">
              Selling Real Estate One Relationship at a Time.
            </h1>
          </FadeInUp>

          <FadeInUp delay={0.2} data-id="element-173">
            <p className="text-base md:text-xl text-white font-medium max-w-3xl mx-auto leading-relaxed mb-10 text-balance" style={{
            textShadow: '0 2px 8px rgba(0,0,0,0.8)'
          }} data-id="element-174">
              John & Mickie Beshk have helped thousands of Phoenix Metro
              families find home for over 30 years. Local expertise. Trusted
              guidance. Lifelong relationships.
            </p>
          </FadeInUp>

          <FadeInUp delay={0.3} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4" data-id="element-175">
            <a href="#" className="w-full sm:w-auto px-8 py-4 bg-terracotta text-white rounded font-medium hover:bg-terracotta/90 transition-colors shadow-lg text-center" data-id="element-176">
              Search Homes
            </a>
            <a href="#" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white text-white rounded font-medium hover:bg-white/10 transition-colors text-center" data-id="element-177">
              Get My Home's Value
            </a>
          </FadeInUp>
        </div>
      </section>

      {/* Stat Strip — separate section beneath the hero on mobile; overlays the hero base on desktop */}
      <div className="relative z-10 bg-[#2A2A2A] md:bg-[#2A2A2A]/90 md:backdrop-blur-md md:-mt-24 border-t border-white/10" data-id="element-178">
        <div className="container mx-auto px-6 py-8 md:pt-4 md:pb-6" data-id="element-179">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 text-center divide-x-0 md:divide-x divide-white/20" data-id="element-180">
            <div className="flex flex-col items-center justify-center" data-id="element-181">
              <span className="text-white font-serif text-xl md:text-2xl mb-1" data-id="element-182">
                30+
              </span>
              <span className="text-[9px] md:text-[10px] uppercase tracking-widest text-white/70" data-id="element-183">
                Years Experience
              </span>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-184">
              <span className="text-white font-serif text-xl md:text-2xl mb-1" data-id="element-185">
                1,000+
              </span>
              <span className="text-[9px] md:text-[10px] uppercase tracking-widest text-white/70" data-id="element-186">
                Families Served
              </span>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-187">
              <span className="text-white font-serif text-xl md:text-2xl mb-1" data-id="element-188">
                5-Star
              </span>
              <span className="text-[9px] md:text-[10px] uppercase tracking-widest text-white/70" data-id="element-189">
                Rated
              </span>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-190">
              <span className="text-white font-serif text-xl md:text-2xl mb-1" data-id="element-191">
                100%
              </span>
              <span className="text-[9px] md:text-[10px] uppercase tracking-widest text-white/70" data-id="element-192">
                Locally Owned
              </span>
            </div>
          </div>
        </div>
      </div>
    </>;
}